import type { ReactNode } from 'react'
import { Container, VStack, styled } from '../styled-system/jsx'
import { PageNavigation } from './page-navigation'

interface VenueOnboardingShellProps {
    title: string
    description: string
    children: ReactNode
    navigation?: {
        readonly items: readonly { readonly label: string; readonly to?: string }[]
    }
    wide?: boolean
}

export function VenueOnboardingShell({ title, description, children, navigation, wide = false }: VenueOnboardingShellProps) {
    return (
        <Container
            maxW={wide ? '6xl' : 'lg'}
            mx={wide ? '0' : 'auto'}
            py={wide ? { base: '7', md: '8' } : { base: '10', md: '16' }}
            px={{ base: '4', md: '6' }}
        >
            <VStack gap="8" alignItems="stretch">
                {navigation && <PageNavigation {...navigation} />}
                <VStack gap="3" alignItems={wide ? 'start' : 'center'} textAlign={wide ? 'left' : 'center'}>
                    <styled.h1 fontSize={{ base: '2xl', md: '3xl' }} fontWeight="bold">
                        {title}
                    </styled.h1>
                    <styled.p color="fg.muted" maxW={wide ? 'full' : 'md'}>
                        {description}
                    </styled.p>
                </VStack>
                {children}
            </VStack>
        </Container>
    )
}
